// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 3H8V15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M20 21V3H16V21H20Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4 21V3H8V21H4Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 3V21M4 3H8M4 3H3M20 3V21M20 3H16M20 3H21M4 21H3M4 21C9 21 3 21 8 21M20 21H21M20 21H16M8 3H16M8 3C8 8.9797 8 9.84222 8 15M8 21H16M8 21C8 19.5597 8 16.2423 8 15M16 3V15M16 21V15M8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-5',
    ref,
    icon: element,
  },
));

Dam5Icon.displayName = 'Dam5Icon';

export default Dam5Icon;
